import React from 'react'
import { Container, Row, Col, Button } from 'react-bootstrap'
import './BookingSection.css'
import { Link } from 'react-router-dom'

const BookingSection = () => {
  return (
    <Container className='py-5'>
      <section className=" booking-section ">
        <Row className="align-items-center gy-3">
          <Col md={2} className="d-flex align-items-center">
            <img src="/elite-optix-logo-2.png" alt="logo" className="booking-logo" />
          </Col>
          <Col md={7}>
            <h3 className="booking-title">Ready to elevate your vision?</h3>
            <p className="booking-sub">Book your personalized eye consultation today.</p>
          </Col>
          <Col md={3} className="d-flex justify-content-md-end gap-2">
            <Button className="booking-btn booking-btn-primary" as={Link} to="/contact">Schedule Now</Button>
            <Button className="booking-btn booking-btn-outline" as={Link} to="/contact">Call Us</Button>
          </Col>
        </Row>
      </section>
    </Container>
  )
}

export default BookingSection
/* duplicate stub removed */